<template>
  <v-card class="mt-6" rounded>
    <v-card-text>
      <v-list shaped>
        <v-list-item link class="text-h5" :to="{ path: '/project' }">
          <v-list-item-icon>
            <v-icon x-large>{{ app.projectIcon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-h4 text-uppercase">
              Project
            </v-list-item-title>
            <v-list-item-subtitle class="text-h6"
              >Project Setting Definitions</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link class="text-h5" :to="{ path: '/system' }">
          <v-list-item-icon>
            <v-icon x-large>{{ app.systemIcon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-h4 text-uppercase">
              Systems ({{ admin.systemList.length }})
            </v-list-item-title>
            <v-list-item-subtitle class="text-h6"
              >Major Systems (Audio, Lighting, etc)</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link class="text-h5" :to="{ path: '/product' }">
          <v-list-item-icon>
            <v-icon x-large>{{ app.productIcon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-h4 text-uppercase">
              Products ({{ admin.productList.length }})
            </v-list-item-title>
            <v-list-item-subtitle class="text-h6"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link class="text-h5" :to="{ path: '/attribute' }">
          <v-list-item-icon>
            <v-icon x-large>{{ app.attributeIcon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-h4 text-uppercase">
              Attributes ({{ admin.attributeList.length }})
            </v-list-item-title>
            <v-list-item-subtitle class="text-h6"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        drawer: ''
      };
    },
    computed: {
      ...mapState(['app', 'admin'])
    },
    methods: {}
  };
</script>
